import { render, staticRenderFns } from "./RequestIntroTab.vue?vue&type=template&id=6480eec2"
import script from "./RequestIntroTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestIntroTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RequestIntroTab.vue?vue&type=style&index=0&id=6480eec2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports